<template>
	<v-row v-if="!$store.getters.progress" class="ma-0">
		<v-col class="pa-0">
            <v-tabs
			class="fill-height"
                :height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab :key="1" ripple>DDT di acquisto</v-tab>

                <v-tab-item :key="1" class="pb-offset background-1">

                    <show
                        :id="id"
                        :models="models"
                        :infos="infos"
						topClass="mx-0 pt-2"
                    ></show>

                    <v-col class="pa-0">
						<v-card class="flex pa-0 background-2 round-card">
                			<v-card-title class="pa-3">
				    			<p class="pl-2 pl-xl-3">{{ supplierReturn ? 'Dati DDT di reso a fornitore' : 'Dati DDT di Vendita' }}</p>
								<v-spacer></v-spacer>
			                </v-card-title>        
							<v-divider></v-divider>
							<v-container class="pt-3" fluid>
								<fields-generator
									:fieldsset.sync="fieldsset"
									:model="saleddt"
									ref="fieldsgenerator"
									:selectChange="onChange"
								></fields-generator>
								<small class="pl-4">* Indica i campi obbligatori</small>
							</v-container>
						</v-card>
					</v-col>

					<v-col class="pa-0 pt-4" v-if="relations.products.collection">
						<v-card class="flex pa-0 background-2 round-card">
                			<v-card-title class="pa-3">
								<p class="pl-2 pl-xl-3">Conversione Prodotti</p>
								<v-spacer></v-spacer>
									<v-switch
										inset
										style="padding-top: 0; margin: auto"
										label="Converti tutto"
										v-model="processAll"
										hide-details
										color="primary"
									></v-switch>
				                </v-card-title>
							<v-divider></v-divider>
							<v-container class="pa-0" fluid>
								<v-row class="ma-0 pt-0">
									<v-col cols="12" class="pa-0">
										<v-card class="flex background-2" elevation="0">
											<v-data-table
												class="background-2 no-max-height"
												:headers="relations.products.info.fieldDefs"
												:items="relations.products.collection"
												hide-default-footer
												disable-pagination
												item-key="id"
												show-expand>
												<template v-slot:item="{item, select, isSelected, expand, isExpanded, headers, index}">
													<tr>
														<template v-for="(header, h) in headers">
															<td v-if="header.value == 'data-table-expand'" :key="'expand-'+h">
																<v-btn
																	v-if="item.description"
																	icon
																	small
																	@click.stop="expand(!isExpanded)">
																	<v-icon :size="24" color="info">mdi-file-document</v-icon>
																</v-btn>
															</td>
															<td v-else-if="header.value === 'number'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															:key="h">
																{{ index +1 }}
															</td>
															<td v-else-if="header.value == 'price'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															:key="h">
																{{ $eventBusUtility.headerValue(header.value, item) | currency }}
															</td>
															<td v-else-if="header.value === 'quantity'" :key="'quantity-'+h">
																<v-chip small color="grey darken-1" dark>
																	<v-icon small left>mdi-package-variant</v-icon>
																	{{ item.quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.value === 'unload_quantity'" :key="'unloaded-'+h">
																<v-chip
																	small
																	:color="item.unload_quantity > 0 ? 'success' : 'grey lighten-1'"
																	:dark="item.unload_quantity > 0">
																	<v-icon small left>mdi-check-circle</v-icon>
																	{{ item.unload_quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.value == 'quantity_to_unload'"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															width="200px"
															style="padding-right: 24px !important;" :key="h">
																<v-text-field
																	v-model.number="item.quantity_to_unload"
																	class="conversion-quantity"
																	label="Quantità"
																	type="number"
																	min="0"
																	hide-details
																	autofocus
																	dense
																	outlined
																	:error-messages="errors.collect('Quantità_'+item.id)"
																	v-validate="'required|min_value:0|max_value:'+getMaxDispatchable(item)"
																	:data-vv-name="'Quantità_'+item.id"
																	data-vv-as="Quantità"
																></v-text-field>
															</td>
															<td v-else-if="header.value === 'selected_lot_allocations'" :key="'lots-'+h">
																<conversion-lots-cell :item="item" quantity-key="quantity_to_unload"></conversion-lots-cell>
															</td>
															<td v-else :class="'text-xs-'+header.align" :key="h">
																{{ $eventBusUtility.headerValue(header.value, item) }}
															</td>
														</template>
													</tr>
												</template>
												<template v-slot:expanded-item="{ item, headers }">
													<tr>
									    				<td :colspan="headers.length" class="pa-0">
															<v-card class="elevation-0">
																<v-card-text pa-4 v-html="item.description"></v-card-text>
															</v-card>
														</td>
													</tr>
												</template>
											</v-data-table>
											<v-divider></v-divider>
										</v-card>
									</v-col>
								</v-row>
								<v-row class="pa-0" justify="center">

									<v-col lg="3" md="3" sm="6">                            
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità</v-list-item-title>
													<v-list-item-subtitle>{{ totalQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-col>
									<v-col lg="3" md="3" sm="6">
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità convertita</v-list-item-title>
													<v-list-item-subtitle>{{ totalUnloadQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>       
									</v-col>
									<v-col lg="3" md="3" sm="6">
										<v-list two-line class="background-2">
											<v-list-item>
												<v-list-item-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>Totale Quantità da convertire</v-list-item-title>
													<v-list-item-subtitle>{{ totalQuantity - totalUnloadQuantity }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</v-list>       
									</v-col>

								</v-row>
							</v-container>
						</v-card>
					</v-col>
					<v-tooltip top>
                        <template v-slot:activator="{ on: tooltip }">
							<v-fab-transition>
								<v-btn
                                    v-on="{ ...tooltip }"
									@click.native="validateUnload()"
									:loading="saved"
									color="primary"
									dark
									fixed
									bottom
									right
									fab>
									<v-icon>input</v-icon>
								</v-btn>
							</v-fab-transition>
                        </template>
						<span>Evadi quantità</span>
					</v-tooltip>

					<confirm-dialog
						:confirmModel="confirmUnload"
						mainTitle="Vuoi convertire le quantità da te selezionate?"
						:secondTitle="supplierReturn
							? 'Sarà creato un DDT di reso a fornitore con le quantità scelte: la merce verrà scaricata dal magazzino'
							: 'Sarà creato un DDT di Vendita con le quantità dei prodotti da te scelte'"
						@update:confirmModel="confirmUnload = false"
						:atConfirm="processOrder"
					></confirm-dialog>
                </v-tab-item>
            </v-tabs>
		</v-col>
	</v-row>
</template>

<script>

	import Vue from 'vue'
	import ConversionLotsCell from '@/components/common/ConversionLotsCell'
	import { missingSerials, conversionPayloadRows } from '@/components/common/conversionLots'

	export default {
		name: 'purchaseddt-unload',
		components: { ConversionLotsCell },
		props: {
			id: Number,
			// reso a fornitore: crea un DDT di acquisto con causale che scarica
			// invece di un DDT di vendita
			supplierReturn: Boolean,
		},
		
		data() {
			return {
                infos: {},
                models: {},
				modelDef: 'purchaseddts',
				dialog: false,
				processAll: false,
				confirmUnload: false,
				fieldsset: {},
				saleddt: {},
				relations: { products: { collection: [], info: { fieldDefs: [] } } },
				defaultInput: {},
				// true solo mentre checkDefaultInput lancia le cascade dei valori d'origine
				applyingDefaultInput: false,
				saved: false
			}
		},

		watch: {
			processAll: {
				handler(newValue, oldValue) {
					_.forEach(this.saleddt.products, (product) => {
						if(newValue) {
							Vue.set(product, 'quantity_to_unload', product.quantity - product.unload_quantity)
						} else {
							Vue.set(product, 'quantity_to_unload', 0)
						}
					})
				}
			}
		},

		computed: {
            
            totalQuantity() {
                return this.relations.products.collection.reduce((acc, product) => acc + product.quantity, 0);
            },

            totalUnloadQuantity() {
                return this.relations.products.collection.reduce((acc, product) => acc + product.unload_quantity, 0);
            }

        },

		created() {

			const infoUrl = 'purchaseddts-info-unload/' + this.id + (this.supplierReturn ? '?supplier_return=1' : '')
			this.axios.get(infoUrl).then(response => {
				// get body data
                this.models = response.data.models
				this.infos = response.data.infos
				this.relations = response.data.relations				
                this.fieldsset = response.data.fields
				this.saleddt.products = this.relations.products.collection
				
				_.forEach(this.fieldsset.fields, (value, key) => {
					if(value.type === 'checkbox' || value.type === 'file') {
						Vue.set(this.saleddt, value.key, '')
					}
					if(value.default) {
						Vue.set(this.saleddt, value.key, value.default)
					}
				})
				_.forEach(this.saleddt.products, (product) => {
					Vue.set(product, 'quantity_to_unload', 0)
				})
				this.$store.commit('endProgress') 

				// reso a fornitore: fornitore, magazzino e causale dal DDT d'origine;
				// DDT di vendita: la causale senza movimento se l'origine non ha caricato.
				// checkDefaultInput lancia anche le cascade, quindi aspetta che il form sia montato
				if(response.data.default_input) {
					this.defaultInput = response.data.default_input
					this.$nextTick(() => {
						this.applyingDefaultInput = true
						this.$eventBusUtility.checkDefaultInput(this, 'saleddt')
						this.applyingDefaultInput = false
					})
				}

			}, response => {
				// error callback
				this.$store.commit('endProgress')
				this.$router.back()
			})

		},

		methods: {

			roundNumber(num) {
				return Math.round(num * 100 + Number.EPSILON) / 100
			},

			getMaxDispatchable(item) {
				return this.roundNumber(item.quantity - item.unload_quantity)
			},

            // Call at change select option
            onChange(field, event) {
                // I valori d'origine (es. la destinazione) vanno rimessi dopo le cascade che checkDefaultInput
                // lancia all'apertura (quella del fornitore li azzera); passati anche dopo, bloccherebbero i campi
                // derivati dal fornitore e riscriverebbero quelli cambiati a mano a ogni cascade successiva
                const defaultInput = this.applyingDefaultInput ? this.defaultInput : {}
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.saleddt, null, defaultInput)).then((responses) => {
                    responses.forEach(response => {
                        if(this.saleddt[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.saleddt[response.key])
                        }
                    })
                })
			},

			validateUnload() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					const missing = missingSerials(this.relations.products.collection, 'quantity_to_unload')
					if (missing.length) {
						this.$store.commit('setSnackbar', {
							timeout: 8000,
							text: 'Indica le matricole di: ' + missing.join(', '),
							value: true,
							color: 'error'
						})
						return false
					}
					this.confirmUnload = true
				}).catch(() => {

				})
			},
			
			processOrder() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					}
					const url = this.supplierReturn ? 'purchaseddts-supplier-return/' : 'purchaseddts-unload/'
					const payload = Object.assign({}, this.saleddt, { products: conversionPayloadRows(this.saleddt.products) })
					this.axios.post(url + this.id, payload).then(response => {
						// get body data
						const showRoute = this.supplierReturn ? 'purchaseddts-show' : 'ddts-show'
						this.$router.push({ name: showRoute, params: { id: parseInt(response.data.id) }})

					}, response => {
						// error callback
					});
				}).catch(() => {

				})
			},

		},
	}
</script>

<style>
	.no-max-height .v-data-table__wrapper {
		max-height: none !important;
	}
</style>